import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ReactComponent as LoaderSVG } from '../../icons/loader.svg';

import './button.scss';

const Button = ({
  color,
  onClick,
  disabled = false,
  loading = false,
  label,
  className,
}) => {
  const colorsMap = {
    red: 'btn-red',
    green: 'btn-green',
    purple: 'btn-purple',
    white: 'btn-white',
  };
  const buttonDisabled = disabled || loading;
  const btnClasses = classnames(
    `btn-base ${colorsMap[color]} ${className ?? ''}`,
    {
      'btn-loading': loading,
      disabled: buttonDisabled,
    },
  );
  const props = {
    disabled: buttonDisabled,
    onClick: buttonDisabled ? () => true : onClick,
    className: btnClasses,
  };

  return (
    <button {...props}>
      {!loading && <span>{label}</span>}
      {loading && (
        <span>
          <LoaderSVG />
        </span>
      )}
    </button>
  );
};

Button.propTypes = {
  color: PropTypes.oneOf(['red', 'green', 'white']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Button;
